import React from "react";
import { Flex } from "../../atoms/flex";

/**
 * Graph skeleton
 */

export const GraphSkeleton = () => {
  return (
    // <div className="graphLoading" />
    <Flex className="Graph">
      <svg
        width="512px"
        height="512px"
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g className="Baseplate">
          <path
            style={{ fill: "#BFBFBF" }}
            d="M143.5,347H451l-48,56H40L143.5,347z"
          />
          <path style={{ fill: "#A3A2A2" }} d="M40,403h363v14H40V403z" />
          <path style={{ fill: "#898686" }} d="M403,403l48-56v14l-48,56V403z" />
          {/* <text x="256" y="461" className="ChartHeading">
          {description}
        </text> */}
        </g>
        <g className="Max">
          <g>
            <rect
              x="128"
              y="114"
              style={{ fill: "#FC8997" }}
              width="111"
              height="282"
            />
            <path
              style={{ fill: "#E07582" }}
              d="M175,95h93l-29,19H128L175,95z"
            />
            <path
              style={{ fill: "#D24962" }}
              d="M239,114l29-19l-2,261l-27,40V114z"
            />
          </g>
        </g>
        <g className="Min">
          <g>
            <rect
              x="252"
              y="339.6"
              style={{ fill: "#89C5FC" }}
              width="111"
              height="56.40000000000001"
            />
            <path
              style={{ fill: "#75ADE0" }}
              d="M 252 339.6 295 320.6 390 320.6 363 339.6 Z"
            />
            <path
              style={{ fill: "#4991D2" }}
              d="M 363 339.6 390 320.6 390 360 363 394"
            />
          </g>
        </g>
      </svg>
    </Flex>
  );
};
